export const ConfirmAcceptWrapper = 'flex flex-col text-center gap-6'
export const ConfirmAcceptActions = 'flex justify-center gap-4'
